// File: /src/components/SettingsSection.js
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

function SettingsSection({ toggleTheme: toggleThemeProp }) {
	const { savedPreference, toggleTheme: toggleThemeContext } = useTheme();
	
	// Use prop if provided, otherwise fallback to context
	const toggleTheme = toggleThemeProp || toggleThemeContext;

	const handleThemeChange = (e) => {
		const selectedTheme = e.target.value;
		toggleTheme(selectedTheme);
	};

	return (
		<div className="settings-section">
			<h2>Configurações</h2>
			<form className="user-account-form">
				<div className="form-row settings-row">
					<label className="settings-label">Tema do Aplicativo</label>
					<select
						className="theme-select"
						value={savedPreference}
						onChange={handleThemeChange}
					>
						<option value="system">Sistema</option>
						<option value="light">Claro</option>
						<option value="dark">Escuro</option>
					</select>
				</div>
			</form>
		</div>
	);
}

export default SettingsSection;
